document.addEventListener('alpine:init', () => {
    function debounce(func, timeout = 300){
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }

    Alpine.data('tableScrollHandler', () => ({
        intervalId: null,
        step: 6,
        delay: 10,
        isAtStart: true,
        isAtEnd: false,

        init() {
            this.reInit();
            window.addEventListener('resize', debounce(() => this.reInit()));
        },

        reInit() {
            const elem = this.$refs.table;
            let scrollWidth = elem.scrollWidth;
            let clientWidth = elem.clientWidth;

            this.isAtEnd = clientWidth >= scrollWidth;

            this.$watch('isAtStart', (value) => {
                if (value) {
                    this.stopScroll()
                }
            });
            this.$watch('isAtEnd', (value) => {
                if (value) {
                    this.stopScroll()
                }
            });
        },

        startScroll(event, direction) {
            clearInterval(this.intervalId);
            this.intervalId = setInterval(() => {
                let currentScroll = this.$refs.table.scrollLeft;
                this.$refs.table.scrollLeft = direction === 'right' ? currentScroll + this.step : currentScroll - this.step;
            }, this.delay);
        },

        stopScroll() {
            clearInterval(this.intervalId);
        },

        handleScroll(event) {
            const elem = event.target;
            let scrollLeft = elem.scrollLeft;
            let scrollWidth = elem.scrollWidth;
            let clientWidth = elem.clientWidth;
            let reachedEnd = scrollLeft >= scrollWidth - clientWidth;

            this.isAtStart = scrollLeft <= 0;
            this.isAtEnd = reachedEnd;
        },
    }));
});
